module.exports = __webpack_public_path__ + "img/lock.2b17cfb3.svg";